(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-odp]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('[data-odp-track]');
      if (!track) return;
      section.querySelector('[data-odp-prev]')?.addEventListener('click', () => track.scrollBy({left:-track.clientWidth*.8}));
      section.querySelector('[data-odp-next]')?.addEventListener('click', () => track.scrollBy({left:track.clientWidth*.8}));
      if (section.classList.contains('odp--offer')) {
        const items = [...track.children];
        const thumbs = document.createElement('div');
        thumbs.className = 'odp__thumbs';
        items.forEach((item,index) => {
          const image = item.querySelector('img');
          if (!image) return;
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', image.alt || `Image ${index+1}`);
          button.setAttribute('aria-pressed', String(index===0));
          const thumbnail = image.cloneNode();
          thumbnail.removeAttribute('srcset');
          thumbnail.removeAttribute('sizes');
          button.append(thumbnail);
          button.addEventListener('click', () => {
            items.forEach((slide,i) => { slide.style.display = i===index?'block':'none'; });
            [...thumbs.children].forEach((b,i) => b.setAttribute('aria-pressed',String(i===index)));
          });
          thumbs.append(button);
        });
        const gallery = document.createElement('div');
        gallery.className = 'odp__gallery';
        track.before(gallery);
        gallery.append(track,thumbs);
      }
    });
  };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load',e=>initialize(e.target.parentElement));
})();
